// extracted by mini-css-extract-plugin
export var sliderRange = "_ci-2";
export var sliderRoot = "_ci-0";
export var sliderThumb = "_ci-3";
export var sliderTrack = "_ci-1";